import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../';
import { useOktaAuth } from '../../../../hooks/use-okta-auth';
import { useBranchContext } from '../../../../context/BranchContext';
import { useBranchId } from '../../../../hooks/use-branch-id';
import { useBranchData } from '../../../../hooks/use-branch-data';
import { isValidArray } from '../../../utilities/validations';

import LocationButton from '../location-button';

import './index.css';

const GlobalNav = ({ data }) => {
	const { isLogged, profile } = useOktaAuth();
	const { currentBranch } = useBranchContext();
	const branchId = useBranchId();
	const branchData = useBranchData();
	const [loading, setLoading] = useState(true);
	const [showPro, setShowPro] = useState(false);
	const isDesktop = useMediaQuery({ query: '(min-width: 1280px)' });

	useEffect(() => {
		setLoading(false);
		const urls = ['/professionals/', '/pcc/', '/ppc/', 'PCC'];
		if (typeof window !== 'undefined' && urls.some((url) => window.location.href.indexOf(url) !== -1)) {
			setShowPro(true);
		} else {
			setShowPro(false);
		}
	}, []);

	useEffect(() => {
		if (isLogged && profile.isPro) {
			setShowPro(true);
		}
	}, [isLogged, profile.isPro]);

	if (!data) return null;

	return (
		<div
			id='globalNav'
			className='hidden h-10 xl:block'
		>
			<List
				bullets='none'
				layout='inline'
				role='navigation'
				aria-label='Secondary Navigation'
				className='justify-end'
			>
				{!loading && isDesktop && (
					<li className='globalNav-LocBtn relative z-20 flex items-center font-semibold !leading-[40px] lg:text-base'>
						<LocationButton />
					</li>
				)}

				{isValidArray(data) &&
					data
						.filter((link) => link.gtm_link_type !== 'button')
						.map((group, index) => {
							const careersLink = currentBranch?.local_nav?.find((item) => item.link.title === 'Careers');

							return (
								<li
									key={index}
									className={`globalNavItem-${index} relative z-20 ml-2.5 pl-2.5 text-sm font-semibold !leading-[40px] 2xl:ml-5 2xl:pl-5 2xl:text-base`}
								>
									<CTA
										data={group.link.title === 'Careers' && careersLink ? careersLink : group}
										className='decoration-transparent hover:decoration-black'
									/>
								</li>
							);
						})}

				{isValidArray(data) &&
					data
						.filter((btn) => btn.gtm_link_type === 'button')
						.map((group, index) => {
							if ((showPro && index === 0) || (!showPro && index === 1)) return null;
							if (currentBranch?.hide_rta && index === 0) return null;
							if (branchData?.find((data) => data.branch_retail?.includes(branchId))?.hide_rta && index === 0) return null;

							return (
								<li
									key={index}
									className={`globalNavItem-btn relative z-20 ml-5 text-sm font-semibold leading-tight 2xl:ml-5 2xl:text-base`}
								>
									<CTA
										data={group}
										className='!border-0 !px-8 !py-0 normal-case !leading-[40px]'
										id='monetate-global-nav-cta'
									/>
								</li>
							);
						})}
			</List>
		</div>
	);
};

GlobalNav.propTypes = {
	data: PropTypes.array,
};

export default GlobalNav;
